module.exports = __webpack_public_path__ + "img/key-map.f67300c5.svg";